// extracted by mini-css-extract-plugin
export var galleryThumbnail = "gallery-thumbnail-module--gallery-thumbnail--LkmK5";
export var blur = "gallery-thumbnail-module--blur--qVN0H";
export var skeleton = "gallery-thumbnail-module--skeleton--PeWDl";
export var Skeleton = "gallery-thumbnail-module--Skeleton--nver1";